import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import emailSenderApi from '@/features/dashboard/emailSender/api/emailSenderApi.ts';
import { emailSenderApiQueryKeys } from '@/features/dashboard/emailSender/api/emailSenderApi.queryKeys.ts';
import { EmailSenderSettingsDto } from '@/features/dashboard/emailSender/types/EmailSenderSettingsDto.ts';
import { emailSenderSettingsMapper } from '@/features/dashboard/emailSender/types/EmailSenderSettingsDto.mapper.ts';
import { EmailSenderFormData } from '@/features/dashboard/emailSender/schemas/emailSenderSchema.ts';

export default function useSetEmailSenderSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (form: EmailSenderFormData) =>
      emailSenderApi.set(emailSenderSettingsMapper.fromFormToDto(form)),
    onMutate: () => ({
      previous: queryClient.getQueryData<EmailSenderSettingsDto>(
        emailSenderApiQueryKeys.all(),
      ),
    }),
    onSuccess: (data, _form, context) => {
      queryClient.setQueryData(emailSenderApiQueryKeys.all(), data);
      const fromEmailRequested =
        data.fromEmail !== null &&
        data.fromEmail !== context?.previous?.fromEmail;
      const replyToRequested =
        data.replyToEmail !== null &&
        data.replyToEmail !== context?.previous?.replyToEmail;
      if (fromEmailRequested || replyToRequested) {
        toast.success(
          'Zgłoszenie wysłane — odezwiemy się w sprawie aktywacji',
          {
            description: fromEmailRequested
              ? 'Skontaktujemy się w sprawie konfiguracji DNS Twojej domeny. Do czasu zatwierdzenia maile wychodzą z domeny Campdesk.'
              : 'Nowy adres Reply-To zacznie działać po zatwierdzeniu przez Campdesk.',
          },
        );
      } else {
        toast.success('Ustawienia nadawcy zostały zapisane');
      }
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message ||
          'Wystąpił błąd podczas zapisywania ustawień nadawcy.',
      });
    },
  });
}
